import {
  CIMSPage,
  CIMSPageItem,
  alphabeticalCompare,
  pathify,
} from '@cims-online/shared'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import ProjectLink from 'components/ProjectLink'
import { PayItemsWorkflow } from '../InternalConnectionsContext'
import { useGroupColumn } from '../../../hooks/useGroupColumn'
import { HelpMessage } from 'utils/constants'
import { Tooltip } from 'antd'
import CIMSLink from 'components/CIMSLink'
import { useProjectContext } from 'context/ProjectContext'

function label(item: PayItemsWorkflow) {
  return 'internal' in item ? item.internal.module.name : item.workflow.label
}

export function useColumns(): CIMSColumn<PayItemsWorkflow>[] {
  const { projectId } = useProjectContext()
  return [
    {
      title: 'Workflows',
      help: HelpMessage.PayItems.Manage.Internals.Modules,
      width: 300,
      render: (record) => {
        if (!('internal' in record))
          return (
            <CIMSLink
              newTab
              to={pathify(
                projectId,
                'workflows',
                record.workflow.id,
                'records'
              )}
            >
              {record.workflow.label}
            </CIMSLink>
          )
        const { classType, module } = record.internal
        let item: CIMSPageItem | undefined = undefined
        if (classType === 'ConstructionAdminSubmittal')
          item = CIMSPage.CASTracker
        else if (classType === 'ConcreteTestSet')
          item = CIMSPage.ConcreteTestSets
        else if (classType === 'DesignSubmittal') item = CIMSPage.DSLog
        else if (classType === 'FieldDesignChange') item = CIMSPage.FDCTracker
        else if (classType === 'Issue') item = CIMSPage.IssueTracker
        else if (classType === 'EngineeringJudgement') item = CIMSPage.EJLog
        if (!item)
          return <Tooltip title="Unknown CIMSPage">{module.name}</Tooltip>
        return (
          <ProjectLink item={item} newTab>
            {module.name}
          </ProjectLink>
        )
      },
      sort: {
        with: 'callback',
        onCompare: (a, b) => alphabeticalCompare(label(a), label(b)),
        default: 'ascend',
      },
      filter: {
        type: 'search',
        with: 'callback',
        onFilter: (value, record) =>
          label(record).toLowerCase().includes(value.toString().toLowerCase()),
      },
    },
    useGroupColumn(),
  ]
}
